import backgroundMoonImage from "../assets/images/moon-background.png";
import backgroundDhulHijjahImage from "../assets/images/hajj-3.jpg";
import backgroundDuskImage from "../assets/images/dusk-sky.png";
import backgroundMasjidImage from "../assets/images/madina.jpg";
import backgroundOGN from "../assets/images/ogn-bn.jpg";
import defaultQuoteIcon from "../assets/images/custom-quote.png";
import { DEFAULT_CLOUD_IMAGES } from "../components/FloatingClouds";
import {
  getCanonicalTemplateKey,
  isDhulHijjahTemplateKey,
  isFridayTemplateKey
} from "./templateUtils";

const buildThemeConfig = (overrides = {}) => ({
  backgroundImage: backgroundMoonImage,
  quote: "",
  reference: "",
  quoteIcon: defaultQuoteIcon,
  quoteAlt: "custom-quote",
  cloudImages: DEFAULT_CLOUD_IMAGES,
  showShootingStars: false,
  showClouds: false,
  showBirdAnimation: false,
  ...overrides
});

export const getDonationThemeConfig = ({ template, ref, t }) => {
  const templateKey = getCanonicalTemplateKey(template);

  let themeVariant = "ramadan";

  if (template === "Rajab") {
    themeVariant = "rajab";
  } else if (isFridayTemplateKey(templateKey)) {
    themeVariant = ref && ref.toLowerCase().includes("ogn") ? "fridayOgn" : "friday";
  } else if (isDhulHijjahTemplateKey(templateKey)) {
    themeVariant = "dhulHijjah";
  }

  switch (themeVariant) {
    case "rajab":
      return buildThemeConfig({
        backgroundImage: backgroundDuskImage,
        quote: t("rajabQuote"),
        reference: t("rajabReference")
      });

    case "fridayOgn":
      return buildThemeConfig({
        backgroundImage: backgroundOGN,
        quote: t("fridayQuote"),
        reference: t("fridayReference")
      });

    case "friday":
      return buildThemeConfig({
        backgroundImage: backgroundMasjidImage,
        quote: t("fridayQuote"),
        reference: t("fridayReference")
      });

    case "dhulHijjah":
      // Keep Dhul Hijjah aligned with the current Hijri look for now,
      // but this case is now isolated so its art/toggles can diverge later.
      return buildThemeConfig({
        backgroundImage: backgroundDhulHijjahImage,
        quote: t("dhulHijjahQuote"),
        reference: t("dhulHijjahReference"),
        showShootingStars: false,
        showClouds: true,
        showBirdAnimation: false
      });

    default:
      return buildThemeConfig({
        backgroundImage: backgroundMoonImage,
        quote: t("ramadanQuote"),
        reference: t("ramadanReference"),
        showShootingStars: true,
        showClouds: true,
        showBirdAnimation: true
      });
  }
};
